import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowTriangleRight"><Path d="M4 3.38184V20.6179L21.2361 11.9999L4 3.38184Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleRight;
